<template>
  <div class="app-router">
    <h2 class="font-weight-bold">Pengaturan Pengiriman</h2>
    <div class="text-subtitle-2 pb-5">
      Pengaturan yang berhubungan dengan jasa kirim
    </div>

    <v-layout v-resize="onResize" column>
      <v-card outlined class="px-3 py-3">
        <v-card-title
          class="pt-0 px-2 text-subtitle-1 font-weight-bold black--text darken-4 d-flex flex-row align-center"
        >
          Jasa Kirim
          <span class="text-caption" :class="{ 'pl-4': !isMobile }"
            >Aktifkan jasa kirim yang kamu inginkan</span
          >
        </v-card-title>
        <v-card-text class="pb-0 px-2">
          <p>
            Nikmati pelayanan jasa kirim yang lebih cepat dan handal dengan Jasa
            Kirim yang didukung
            <strong class="primary--text">{{ siteConfig.meta_title }}</strong
            >. Perlu diingat bahwa kamu membutuhkan printer untuk mencetak label
            pengiriman secara otomatis.
          </p>

          <v-row justify="center" class="px-3">
            <v-expansion-panels accordion>
              <v-expansion-panel
                v-if="Object.keys(kurirToko).length > 0"
                class="mb-3"
              >
                <v-expansion-panel-header hide-actions>
                  <v-row
                    class="d-flex flex-row align-center justify-center"
                    v-if="!isMobile"
                  >
                    <v-col cols="4">
                      <v-text-field
                        v-if="kurirToko.store_courier_is_active == '1'"
                        v-model="kurirToko.store_courier_label"
                        label="Nama Kurir"
                        dense
                        hide-details
                        @change="updateKurirDetail"
                        placeholder="Nama Kurir"
                        class="rounded-lg text-body-2"
                      ></v-text-field>
                      <span v-else class="font-weight-bold">{{
                        kurirToko.store_courier_label
                      }}</span>
                      <br />
                    </v-col>
                    <v-col cols="7" class="pt-0">
                      <v-currency-field
                        v-if="kurirToko.store_courier_is_active == '1'"
                        v-model="kurirToko.store_courier_price"
                        label="Biaya Pengiriman"
                        dense
                        hide-details
                        @change="updateKurirDetail"
                        placeholder="Biaya Pengiriman"
                        class="rounded-lg text-body-2"
                      ></v-currency-field>
                    </v-col>
                    <!-- <v-col cols="1" class="text-center">
                      <v-icon @click="editCourierToko" small class="mr-2">mdi-pencil</v-icon>
                    </v-col>  -->
                    <v-col cols="1" class="pl-0">
                      <v-switch
                        v-model="kurirToko.store_courier_is_active"
                        true-value="1"
                        false-value="0"
                        dense
                        @change="updateCourierToko"
                      ></v-switch>
                    </v-col>
                  </v-row>
                  <v-row
                    class="d-flex flex-row align-center justify-center"
                    v-else
                  >
                    <v-col cols="9">
                      <!-- <v-img width="80" :src="`/assets/courier/${item.courier_code}.svg`"></v-img> -->
                      <v-text-field
                        v-if="kurirToko.store_courier_is_active == '1'"
                        v-model="kurirToko.store_courier_label"
                        label="Nama Kurir"
                        dense
                        hide-details
                        @change="updateKurirDetail"
                        placeholder="Nama Kurir"
                        class="rounded-lg text-body-2"
                      ></v-text-field>
                      <span v-else class="d-block mt-5 font-weight-bold">{{
                        kurirToko.store_courier_label
                      }}</span>
                      <br />
                      <v-currency-field
                        v-if="kurirToko.store_courier_is_active == '1'"
                        v-model="kurirToko.store_courier_price"
                        label="Biaya Pengiriman"
                        dense
                        hide-details
                        @change="updateKurirDetail"
                        placeholder="Biaya Pengiriman"
                        class="rounded-lg text-body-2"
                      ></v-currency-field>
                    </v-col>
                    <v-col cols="3" class="text-right">
                      <v-switch
                        v-model="kurirToko.store_courier_is_active"
                        true-value="1"
                        false-value="0"
                        dense
                        @change="updateCourierToko"
                      ></v-switch>
                    </v-col>
                  </v-row>
                </v-expansion-panel-header>
                <v-expansion-panel-content v-if="false">
                  <div class="d-block" v-html="item.deskripsi"></div>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel
                class="mb-3"
                v-for="(item, idx) in courier_map"
                :key="idx"
              >
                <v-expansion-panel-header hide-actions>
                  <v-row
                    class="d-flex flex-row align-center justify-center"
                    v-if="!isMobile"
                  >
                    <v-col cols="3"
                      ><v-img
                        width="80"
                        :src="`/assets/courier/${item.courier_code}.svg`"
                      ></v-img
                    ></v-col>
                    <v-col cols="8"
                      ><span class="font-weight-bold">{{
                        item.courier_name
                      }}</span></v-col
                    >
                    <v-col cols="1" class="pl-0">
                      <v-switch
                        v-model="item.status"
                        dense
                        @change="updateCourier"
                      ></v-switch>
                    </v-col>
                  </v-row>

                  <v-row
                    class="d-flex flex-row align-center justify-center"
                    v-else
                  >
                    <v-col cols="9">
                      <v-img
                        width="80"
                        :src="`/assets/courier/${item.courier_code}.svg`"
                      ></v-img>
                      <span class="d-block mt-5 font-weight-bold">{{
                        item.courier_name
                      }}</span>
                    </v-col>
                    <v-col cols="3" class="text-right">
                      <v-switch
                        v-model="item.status"
                        dense
                        @change="updateCourier"
                      ></v-switch>
                    </v-col>
                  </v-row>
                </v-expansion-panel-header>
                <v-expansion-panel-content v-if="false">
                  <div class="d-block" v-html="item.deskripsi"></div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-row>

          <div v-if="false" class="d-block mt-5">
            <hr />
          </div>
          <v-row justify="center" class="px-3 mt-5" v-if="false">
            <v-col cols="9">
              <div class="text-subtitle-1 black--text font-weight-bold">
                Dikirim Dalam
              </div>
              <span class="text-caption"
                >Ubah jumlah hari "Dikirim dalam" untuk semua produk yang ada di
                toko Anda.</span
              >
            </v-col>
            <v-col cols="3" class="text-right">
              <v-btn
                class="ma-2 text-capitalize font-weight-bold"
                outlined
                block
                @click="openDialog()"
              >
                Ubah
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-layout>

    <v-dialog v-model="dialogDikirimSet" persistent max-width="600">
      <v-card>
        <v-card-title class="headline text-capitalize green--text darken-1">
          Mass Update "Dikirim Dalam"
        </v-card-title>
        <v-card-text class="pb-0">
          <div class="d-flex flex-column align-start justify-start">
            <span class="text-caption pr-4 px-0">
              Fitur di bawah ini memungkinkan kamu untuk memperbarui "Dikirim
              Dalam" untuk seluruh produk yang sedang live. Kamu hanya dapat
              memperbarui hingga 2 hari untuk produk tersedia (ready stock),
              atau lebih dari 7 untuk produk Pre-order.
            </span>
            <div
              class="text-subtitle-1 font-weight-black black--text mt-5 mb-3"
            >
              Dikirim Dalam
            </div>
            <v-text-field
              v-model="dikirimdalam"
              outlined
              x-small
              dense
              hide-details
              width="100px"
            ></v-text-field>
            <span class="col-2"></span>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-row class="text-center">
            <v-btn
              @click="dialogDikirimSet = false"
              class="my-2 px-5 mr-2 text-capitalize"
              outlined
            >
              Batal
            </v-btn>
            <v-btn
              color="green darken-1 white--text"
              @click="dialogDikirimSet = false"
              class="my-2 px-5 text-capitalize"
            >
              Simpan
            </v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";

export default {
  data() {
    return {
      dialogDikirimSet: false,
      dikirimdalam: 0,
      isMobile: false,
    };
  },

  computed: {
    ...mapState("kiriminaja", ["siteConfig"]),
    ...mapState("options", ["courier"]),
    ...mapState("storeSeller", ["detailStore"]),
    ...mapState("store", ["kurirToko"]),

    courier_map() {
      let store_courier = [];
      let courier = [];
      if (this.detailStore) {
        if (this.detailStore.store_courier)
          store_courier = JSON.parse(this.detailStore.store_courier);

        courier = this.courier.map((el) => {
          if (store_courier.includes(el.courier_code)) el.status = true;

          return el;
        });
      }
      return courier;
    },
  },

  methods: {
    ...mapActions("options", ["getCourier"]),
    ...mapActions("store", ["getKurirByToko"]),
    ...mapActions("storeSeller", [
      "getStoreDetail",
      "updateStoreCourier",
      "saveKurirTokoStatus",
    ]),
    ...mapMutations(["makeAlert"]),

    async openDialog() {
      this.dialogDikirimSet = true;
    },
    updateKurirDetail(){
      this.$store.dispatch('storeSeller/saveKurirTokoDetail',{
        store_courier_price: this.kurirToko.store_courier_price,
        store_courier_label: this.kurirToko.store_courier_label,
      }).then(() => {
        this.makeAlert({
          code: "success",
          type: "success",
          message: "Berhasil memperbarui data kurir.",
          show: true,
        });
      })
    },
    updateCourier() {
      let selected_cour = this.courier_map
        .filter((el) => el.status === true)
        .map((el) => el.courier_code);
      this.updateStoreCourier({
        courier: selected_cour,
      }).then(() => {
        this.makeAlert({
          code: "success",
          type: "success",
          message: "Berhasil memperbarui data pengiriman.",
          show: true,
        });
      });
    },
    updateCourierToko() {
      this.saveKurirTokoStatus({
        store_courier_is_active: this.kurirToko.store_courier_is_active,
      }).then(() => {
        this.makeAlert({
          code: "success",
          type: "success",
          message: "Berhasil memperbarui data pengiriman Toko.",
          show: true,
        });
      });
    },
    onResize() {
      if (window.innerWidth < 769) this.isMobile = true;
      else this.isMobile = false;
    },
  },

  async mounted() {
    this.$store.dispatch("setPageTitle", `Pengaturan Pengiriman`);
    await this.getStoreDetail();
    this.getKurirByToko({ store_id: this.detailStore.store_id });
    this.getCourier();
  },
};
</script>